<script>
import Layout from "../../../router/layouts/print";

/**
 * Screen component
 */
/* eslint-disable no-console */
// var converter = require('number-to-chinese-words');
var converter = require('number-to-words');

export default {
  components: { Layout },
  data() {
    return {
      contract: null,
      saleDates: [],
      saleDates_en: [],
      registerDates: [],

      partners: []
    };
  },
  mounted() {
    this.contract = this.data;
    this.saleDates = this.contract.sale_date_show_number.split("-");
    this.saleDates_en = this.contract.sale_date.split("-");
    this.registerDates = this.contract.register_date_show_number.split('-');
    this.partners = this.contract.partners;
  },

  watch: {
    data: function(newVal) { 
      this.contract = newVal;
      this.saleDates = this.contract.sale_date_show_number.split("-");
      this.saleDates_en = this.contract.sale_date.split("-");
      this.registerDates = this.contract.register_date_show_number.split('-');
      this.partners = this.contract.partners;
    }
  },

  methods: {

    formatCurrency(value, sign = '', decimal = '.00') {
      return  sign.length > 1 ? sign + this.$options.filters.numFormat(value, `0,0${decimal}`) : this.$options.filters.numFormat(value, `${sign}0,0${decimal}`);
    },

    toWord(amount) {
      return this.capitalize(converter.toWords(amount));
      // return (converter.toWords(amount) + '').charAt(0).toUpperCase() + this.slice(1);
    },

    capitalize(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

  },

  props: {
    data: null,
  }

};
</script>
<template>
  <Layout>
        <center>
          <div class="col center c-color box-a4 frame-bor">
            <p class="l1"></p>
            <p class="khm title l4">ព្រះរាជាណាចក្រកម្ពុជា</p>
            <p class="cnb title l4">柬埔寨王国</p>
            <p class="khm h5 l4">ជាតិ សាសនា ព្រះមហាក្សត្រ</p>
            <p class="cnb sub-title l5">民族 宗教 君主</p>
            <p class="top-3">
              <img src="../../../assets/images/3symbol.svg" style="width: 150px;"/>
            </p>
            <p class="l5"><br/></p>
            <p class="l5"><br/></p>
            <p class="l5"><br/></p>
            
            <img src="@/assets/images/h-logo.svg" alt height="120" />
            <p><br/></p>
            <p class="khm sub-title l3">ក្រុមហ៊ុនលំនៅឋាន <span class="g-color">អេចស៊ី</span> ឯ.ក</p>
            <p class="enb sub-title l3">LOMNOV THAN <span class="g-color">HC</span> CO., LTD 公司</p>
            <p class="top-3">
              <img src="@/assets/images/3symbol.svg" style="width: 150px;margin-top: 10px; margin-bottom: 40px;"/>
            </p>

            <p class="khm h5 l4">កិច្ចព្រមព្រៀងលក់-ទិញ លំនៅឋាន</p>
            <p class="cnb sub-title l4">住宅买卖协议</p>
            <p class="l1"><br/></p>
            <p class="khm h5 l4">គម្រោង: លំនៅឋាន អេច សែនសុខ</p>
            <p class="cnb sub-title l4">项目: RESIDENCE H SENSOK</p>
            <p class="l1"><br/></p>
            <p class="khm h5 l4">យូនីតលេខ <span class="enb">{{contract && contract.property}}</span> ជាន់ទី: <span class="enb">{{contract && contract.floor}}</span></p>
            <p class="cnb sub-title l4">公寓单元 <span class="cn">{{contract && contract.property}}</span> 第: <span class="cn">{{contract && contract.floor}}楼</span></p>

            <p class="l1"><br/></p>
            <p class="khm small-text">ថ្ងៃទី <span class="enb">{{saleDates[0]}}</span> ខែ {{saleDates[1]}} ឆ្នាំ <span class="enb">{{saleDates[2]}}</span> </p>
            <p class="cn small-text-cn"><span class="cn">{{saleDates[2]}}</span> 年 <span class="cn">{{saleDates[0]}}</span> 月 {{saleDates[1]}} 日 </p>
            <p class="khm small-text">លេខរៀងៈ <span class="enb">{{contract && contract.contract_number}}</span></p>
            <p class="cn small-text-cn">编号: <span class="cn">{{contract && contract.contract_number}}</span></p>
            <p class="l5"><br/></p>
            <p class="l5"><br/></p>
            <p class="">
              <img src="@/assets/images/bellow.svg" style="width: 100px;"/>
            </p>
            <p class="kh doc-footer"><b>អាសយដ្ឋានដីឡូតិ៍លេខៈ</b> 742 ផ្លូវលេខៈ 1952 ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ</p>
            <p class="cnb doc-footer">地址：金边市森速区新金边分区Bayab村1952号路门牌742号；</p>
            <p class="kh doc-footer"><b>ទូរស័ព្ទលេខៈ</b> <span class="enb"> 092 926 688 | 098 926 688 | 089 626 689 | 086 626 689</span></p>
            <p class="en doc-footer"><b>Email:</b> info@h-residence.net|sales@h-residence.net|Facebook: Residence H Cambodia</p>
          </div>

          <div class="col dblack box-a4-long kh">
            <p class="khm title l3" style="margin-top: 0.2cm;">ព្រះរាជាណាចក្រកម្ពុជា</p>
            <p class="cn title l4">柬埔寨王国</p>
            <p class="khm h5 l4">ជាតិ សាសនា ព្រះមហាក្សត្រ</p>
            <p class="cn sub-title l5">民族 宗教 君主</p>
            <p class="top-3">
              <img src="../../../assets/images/3symbol.svg" style="width: 150px;"/>
            </p>
            <p class="khm sub-title top3">កិច្ចព្រមព្រៀងលក់-ទិញ លំនៅឋាន</p>
            <p class="khm sub-title" style="margin-top: -15px">~~~~~~~~~~~~~~~~~~~~~~~</p>
            <p class="cn sub-title" style="margin-top: -9px">住宅买卖协议</p>
            <p class="khm sub-title" style="margin-top: -15px">~~~~~~~~</p>
            <table width="100%" class="doc-content top text-justify">
              <tr>
                <td width="16%"><p>&nbsp;</p></td>
                <td width="84%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td>
                  <p class="khm">ធ្វើឡើងរវាងៈ</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                  <span class="khm">ក្រុមហ៊ុនលំនៅឋាន អេចស៊ី ឯ.ក</span> តំណាងដោយលោកៈ <span class="khm">លឹម ទ្រី</span> កាន់អត្តសញ្ញាណប័ណ្ណសញ្ជាតិខ្មែរលេខៈ 011335234 ចុះថ្ងៃទី 24-01-2019 ការិយាល័យកណ្តាលដីឡូតិ៍លេខៈ 742 ផ្លូវលេខៈ 1952 ភូមិបាយ៉ាប សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ ។  ទូរស័ព្ទលេខៈ 092 926 688 | 098 926 688 | 089 626 689 | 086 626 689 Email: sales@h-residence.net <span class="khm">(ហៅថាភាគី “ក”)</span> ។
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="cnb">订立双方:</p>
                </td>
                <td>
                  <p class="cn text-cn">
                  <span class="enb">LOMNOV THAN HC CO., LTD. </span>公司，代表人：<span class="enb">LIM TRY</span>先生，持柬籍身份证号码：011335234，签发于2019年1月24日，办公室地址：金边市森速区新金边分区Bayab村1952号路门牌742号，电话号码：092 926 688 | 098 926 688 | 089 626 689 | 086 626 689  Email: sales@h-residence.net（以下简称甲方);
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="khm">ជាមួយនិងៈ</p>
                </td>
                <td>
                  <p style="text-align: justify;">លោក/លោកស្រីៈ <span class="khm">{{contract && contract.name}}</span> ភេទៈ {{contract && contract.sex}} ជនជាតិៈ {{contract && contract.nationality}} សញ្ជាតិៈ {{contract && contract.nationality}}
                  កាន់អត្តសញ្ញាណប័ណ្ណ / លិខិតឆ្លងដែនលេខៈ {{contract && contract.id_no}} ចុះថ្ងៃទីៈ {{contract && contract.id_date_show}} ។
                  <span v-for="(partner, index) in partners" :key="index"> និងលោក/លោកស្រីៈ <span class="khm">{{partner.partner_name}}</span> ភេទៈ {{partner.sex}} ជនជាតិៈ {{partner.nationality}} សញ្ជាតិៈ {{partner.nationality}}
                  កាន់អត្តសញ្ញាណប័ណ្ណ / លិខិតឆ្លងដែនលេខៈ {{partner && partner.partner_id_no}} ចុះថ្ងៃទីៈ {{partner && partner.partner_id_date_show}} ។
                  </span>
                  អាសយដ្ឋានបច្ចុប្បន្នៈ {{contract && contract.address}} ទូរស័ព្ទលេខៈ {{contract && contract.phone_no_1}}  {{contract && contract.phone_no_2}} <span class="khm">(ហៅថាភាគី “ខ”)</span> ។
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p class="cnb">与:</p>
                </td>
                <td>
                  <p  class="cn text-cn" style="text-align: justify;"><span class="cn text-cn">{{contract && contract.name_en}} 先生，性别: {{contract && contract.sex == 'ប្រុស' ? '男性' : '女性'}}，国籍: {{contract && contract.nationality_en}}，民族: {{contract && contract.nationality_en}}，</span> 
                  护照号码: {{contract && contract.id_no}} 签发于: {{contract && contract.id_date_show_number}}, 
                  <span v-for="(partner, index) in partners" :key="index"><span class="cn text-cn">{{partner.partner_name_en}}</span> 先生，性别: {{partner.sex == 'ប្រុស' ? '男性' : '女性'}}，国籍: {{partner.nationality_en}}，民族: {{partner.nationality_en}}，
                  护照号码: {{partner && partner.partner_id_no}} 签发于: {{partner && partner.partner_id_date}}, 

                  </span>
                  目前地址: {{contract && contract.address_en}} 电话号码: {{contract && contract.phone_no_1}}  {{contract && contract.phone_no_2}}<b>(以下简称乙方）</b> 
                  </p>
                </td>
              </tr>
            </table>
            <p><br/></p>
            <P class="khm sub-title-zero underline">ភាគីទាំងពីរបានឯកភាពគ្នាចុះកិច្ចព្រមព្រៀងតាមលក្ខខណ្ឌដូចខាងក្រោម៖</P>
            <P class="cn sub-title underline">双方协商一致达成如下条款和条件:</P>
            <table class="doc-content top  text-justify">
              <tr>
                <td width="8%"></td>
                <td width="92%"></td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ 1: កម្មវត្ថុនៃកិច្ចព្រមព្រៀង</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="cnb">第一条 ：协议主旨</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">1.1</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                  ជាកិច្ចព្រមព្រៀងដែលភាគី “ក” យល់ព្រមលក់ និងភាគី “ខ” បានយល់ព្រមទិញខុនដូពីក្រុមហ៊ុន <span class="khm">លំនៅឋាន អេចស៊ី ឯ.ក</span> នៃគម្រោងខុនដូ <span class="khm">“លំនៅឋាន អេច សែនសុខ”</span> យូនីតលេខៈ {{contract && contract.property}} នៅជាន់ទីៈ {{contract && ('0' + contract.floor).slice(-2)}} ទំហំៈ {{contract && formatCurrency(contract.net_size)}}ម៉ែត្រការ៉េ, និងទំហំរួមៈ {{contract && formatCurrency(contract.cross_size)}}ម៉ែត្រការ៉េ, មានទីតាំងស្ថិតនៅដីឡូតិ៍លេខៈ1255 ផ្លូវលេខៈ1978 ភូមិទំនប់ សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn text-cn" style="text-align: justify;">
                  甲方同意出售，而乙方同意向Lomnov Than HC Co., Ltd.公司购买位于金边市森速区新金边分区Tumnup村1978号路1255号地块上Residence H SenSok公寓项目中第 {{contract && ('0' + contract.floor).slice(-2)}} 层的共有面积为 {{contract && formatCurrency(contract.cross_size)}}平方米和私有面积为 {{contract && formatCurrency(contract.net_size)}}平方米的 {{contract && contract.property}} 号单元。
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ 2: តម្លៃខុនដូ</p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="cnb">第二条 ：公寓单元价格</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    2.1
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                  ភាគី “ក” យល់ព្រមលក់ខុនដូ ដែលមានចែងក្នុងប្រការ1 (ចំណុច1.1) ឱ្យទៅភាគី “ខ” ក្នុងតម្លៃៈ <span class="number">{{contract && formatCurrency(contract.price, 'USD', '')}}</span>({{contract && contract.price_show}}ដុល្លារអាមេរិក) ។ បញ្ចុះតម្លៃរួចនៅសល់ៈ <span class="number">{{contract && formatCurrency(contract.sale_price, 'USD', '')}}</span>({{contract && contract.sale_price_show}}ដុល្លារអាមេរិក) ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn text-cn" style="text-align: justify;">
                  甲方同意以 <span class="number">{{contract && formatCurrency(contract.price, 'USD', '')}}</span> ({{contract && toWord(contract.price)}} USD) 的价格将第一条（第1.1项）所载的公寓出售给乙方。 经打折后的价格为 <span class="number">{{contract && formatCurrency(contract.sale_price, 'USD', '')}}</span> ({{contract && toWord(contract.sale_price)}} USD)。
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr>
                <td colspan="2">
                  <p class="khm">ប្រការ 3: ការទូទាត់ប្រាក់</p>
                </td>
              </tr>
              
              <tr>
                <td colspan="2">
                  <p class="cnb">第三条 ：款项的结算</p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    3.1
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                  ប្រាក់ថ្លៃទិញខុនដូចំនួនៈ <span class="number">{{contract && formatCurrency(contract.sale_price, 'USD', '')}}</span> ({{contract && contract.sale_price_show}}ដុល្លារអាមេរិក) ភាគី “ខ” ត្រូវប្រគល់ជូនភាគី “ក” ឱ្យបានគ្រប់ចំនួន តាមកាលវិភាគបង់ប្រាក់ដែលភ្ជាប់ជាឧបសម្ព័ន្ធនៃកិច្ចព្រមព្រៀងនេះ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p  class="cn" style="text-align: justify;">
                  乙方应按照本协议所附的付款时间表足额支付 <span class="number">{{contract && formatCurrency(contract.sale_price, 'USD', '')}}</span>  ({{contract && toWord(contract.sale_price)}} USD) 的公寓价格给甲方。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    3.2
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ក្នុងករណី ភាគី “ខ” យឺតយ៉ាវបង់ប្រាក់ជូន ភាគី “ក” លើសពី៣ថ្ងៃ ភាគី “ខ” យល់ព្រមបង់ប្រាក់ពិន័យជូន ភាគី “ក”
                    ចំនួនៈ0.5%(សូន្យចុចប្រាំភាគរយ)ក្នុង1ថ្ងៃនៃចំនួនទឹកប្រាក់ដែលត្រូវបង់ការយឺតយ៉ាវនេះមិនឱ្យលើសរយៈពេល60ថ្ងៃឡើយគិតពីថ្ងៃដែលបានខកខានបង់ប្រាក់។ បើហួសរយៈពេលនេះ ភាគី “ខ” នៅតែមិនបានបង់ប្រាក់តាមពេលវេលានិងគ្រប់ចំនួនតាមកាលវិភាគបង់ប្រាក់ដូចបានកំណត់ក្នុងកិច្ចព្រមព្រៀងនេះឬឈប់ទិញខុនដូនេះវិញ ប្រាក់ដែលបានបង់កន្លងមកនឹងបានជាប្រយោជន៏របស់ ភាគី “ក” ។ ភាគី “ក” នឹងមិនប្រគល់ប្រាក់ដែលបានបង់កន្លងមកជូនភាគី “ខ” វិញឡើយ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    若乙方迟误付款给甲方超过三天，则乙方同意按照应付款金额每日0.5%（百分之零点五）支付罚款给甲方，但是这迟误不得超过60天，若超过这期限而乙方仍然不按照协议规定的付款时间表准时及足额付款或停止购买该公寓，则已经支付的款项将归甲方所有。甲方将不归还已付款给乙方。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    3.3
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី "ខ" មានសិទ្ធិបង់កាត់ប្រាក់ដើម ឬបង់ផ្តាច់លើកិច្ចព្រមព្រៀងនេះបានគ្រប់ពេលវេលា ក្នុងកំលុងពេលកំពុងបង់រំលស់ជាមួយភាគី "ក" ដោយមិនមានការផាកពិន័យឡើយ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    乙方有权在与甲方分期付款期间付减本金或付清本金，而没有被罚款。
                  </p>
                </td>
              </tr>

              <tr>
                <td class="right">
                  <p class="khli">
                    3.4
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    នៅពេលអគារខុនដូបានសាងសង់រួចរាល់ជាស្ថាពរ ភាគី “ខ” ត្រូវបង់ប្រាក់ដើមឱ្យបានយ៉ាងតិចបំផុត10% (ដប់ភាគរយ) នៃចំនួនទឹកប្រាក់
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    当公寓大楼竣工时，乙方必须按照第2条第2.1项规定支付至少公寓单元购买价的10%（百分之十），则甲方才给予权利在公寓居住。
                  </p>
                </td>
              </tr>

              <tr>
                <td class="right">
                  <p class="khli">
                    3.5
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    នៅពេលខុនដូសាងសង់រួចរាល់ ភាគី “ខ”  ដែលកំពុងបង់រំលស់ជាមួយភាគី “ក”  យល់ព្រមផ្ទេរការបង់ប្រាក់នេះទៅប្រើប្រាស់កម្ចីឥណទានរបស់ធនាគារវិញតាមរយៈការណែនាំធនាគារជាដៃគូរបស់ភាគី “ក” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    在公寓建设竣工后，正在分期付款给甲方的乙方同意通过甲方介绍的银行申请银行贷款。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    3.6
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ដើម្បីទទួលបានឥណទានពីធនាគារ ភាគី “ខ” យល់ព្រមផ្ទេរកាត់ឈ្មោះប័ណ្ណសហកម្មសិទ្ធិពីភាគី “ក” មកភាគី “ខ” ឱ្យបានរួចរាល់ ដោយសោហ៊ុយចំណាយជាបន្ទុករបស់ភាគី “ខ” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    为了可以获得银行贷款，乙方同意将产权证从甲方名字过户到乙方名下，并且费用由乙方承担。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">
                    3.7
                  </p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ខ” យល់ព្រមចំណាយលើថ្លៃសេវាផ្សេងៗមួយចំនួនទៀតរបស់ធនាគារ ដូចជាថ្លៃសេវាដាក់បន្ទុកលើប័ណ្ណកម្មសិទ្ធិ សេវាមេធាវី សេវាធានារ៉ាប់រង សេវាវាយតម្លៃលើអចលនទ្រព្យ សេវាឥណទានកម្ចីរបស់ធនាគារ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    乙方同意支付银行的其他服务费，如：产权证设置负担之服务费、律师费、保险费、不动产评估费、银行贷款服务费等。
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr>
                <td colspan="2">
                  <p class="khm">
                    ប្រការ 4: ការសាងសង់
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="cnb">
                    第四条 ：建设
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.1</p>
                </td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ក” នឹងសាងសង់អគារខុនដូ <span class="khm">“លំនៅឋាន អេច សែនសុខ”</span> ក្នុងរយៈពេល30ខែ (និងរយៈពេលអនុគ្រោះ06ខែ) ដោយគិតចាប់ពីថ្ងៃទី 1 ខែ មករា ឆ្នាំ 2022 តទៅ ។ ប្រសិនបើការសាងសង់អគារខុនដូរួចរាល់មុនកាលកំណត់ក្នុងកិច្ចព្រមព្រៀងនេះ ភាគី “ក” មានកាតព្វកិច្ចជូនដំណឹងទៅភាគី “ខ” ដើម្បីមកពិនិត្យមើលខុនដូរបស់ខ្លួន និងធ្វើលិខិតទទួលសិទ្ធិចូលស្នាក់នៅ ។ ចំណែកភាគី “ខ” ត្រូវអនុវត្តតាមការជូនដំណឹងរបស់ភាគី “ក” និងបង់ប្រាក់ថ្លៃទិញខុនដូដែលនៅសល់ជូនភាគី “ក” តាមកាលវិភាគបង់ប្រាក់ដែលបានភ្ជាប់ក្នុងឧបសម្ព័ន្ធនៃកិច្ចព្រមព្រៀងនេះ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    甲方将自2022年1月1日起30个月（和6月宽恕期）内完成Residence H SenSok公寓项目建设。若公寓建设在本协议规定期限前竣工，则甲方有义务通知乙方来检查自己的公寓单元，并且办理入住函。乙方应按照甲方的通知执行，并且按照本协议所附的付款时间表支付剩下的公寓单元款项给甲方。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.2</p>
                </td>
                <td>
                  <p>ទ្រង់ទ្រាយ និងគ្រឿងសម្ភារៈដែលត្រូវបំពាក់ជូនខុនដូនេះរួមមាន៖<br/></p>
                  <p class="cn text-cn">该公寓单元内安装的设备和单元规模：</p>
                  <p>
                    - អំពូលភ្លើង តាមស្តង់ដារបស់ក្រុមហ៊ុន ។<br/>
                    - មានរ៉ូប៊ីនេទឹក នៅវេរ៉ង់ដា ។<br/>
                    - បន្ទប់ទឹកខណ្ឌផ្ទាំងកញ្ចក់កន្លែងងូតទឹក ផ្កាឈូក ឡាវ៉ាបូជាប់ជញ្ជាំង កញ្ចក់ឆ្លុះមុខ បង្គន់ កង្ហារបឺតក្លិន ។<br/>
                    - ឥដ្ឋការ៉ូ 60x60សង់ទីម៉ែត្រ ដែលនាំចូលពីប្រទេសចិន ។<br/>
                    - ពិដានម្នាងសិលា ជញ្ជាំងលាបថ្នាំ ទ្វារតាមស្តង់ដាក្រុមហ៊ុន និងបង្អួចកញ្ចក់ ។<br/>
                    - តបណ្តាញទឹក និងអគ្គិសនី តាមស្តង់ដាក្រុមហ៊ុន ។<br/>
                    - តុចង្ក្រានបិទម៉ាប មានចង្ក្រានអគ្គិសនី1គ្រឿង ម៉ាស៊ីនបឺតផ្សែង1 ស៊ីងលាងចាន និងទូដាក់សម្ភារៈផ្ទះបាយ លើ/ក្រោម ។<br/>
                    - មានបណ្តាញខ្សែ សម្រាប់ទូរទស្សន៍ខ្សែកាប និងអ៊ីនធើណេត បង្កប់ក្នុងជញ្ជាំង ។<br/>
                    - មានបំពាក់ខ្សែភ្លើង ទុយោទឹក និងទុយោស្ពាន់សម្រាប់ម៉ាស៊ីនត្រជាក់ ។<br/>
                  </p>
                  <p class="cn text-cn">
                    - 使用公司标准的电灯；<br/>
                    - 在阳台有水龙头；<br/>
                    - 厕所设有隔离玻璃作为沐浴间，还有莲蓬头、附于墙壁的洗脸池、镜子、马桶、抽风机；<br/>
                    - 使用中国进口的60x60cm瓷砖；<br/>
                    - 石膏天花板、墙壁油漆、门按公司标准，还有玻璃窗；<br/>
                    - 按公司标准连接水电系统；<br/>
                    - 厨房台面用大理石，还设有1台电炉、1台吸油烟机、洗碗池，以及上下柜；<br/>
                    - 在墙内有预埋电线用于连接有线电视和网络；<br/>
                    - 有安装空调所需的电线、水管和铜管；<br/>
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.3</p>
                </td>
                <td>
                  <p>
                    ភាគី “ក” ត្រូវតបណ្តាញអគ្គិសនី និងបណ្តាញទឹកជូនភាគី “ខ” ដោយថ្លៃសោហ៊ុយជាបន្ទុករបស់ភាគី “ក” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn">
                    甲方应为乙方连接水电系统，而费用由甲方承担。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.4</p>
                </td>
                <td>
                  <p>
                    ក្នុងករណីភាគី “ខ” ចង់ជួសជុល ឬកែប្រែទ្រង់ទ្រាយខុនដូ ត្រូវមានការឯកភាពពីភាគី “ក” ។ ការកែប្រែ ឬជួសជុលខុនដូ ធ្វើទៅបានលុះត្រាតែមិនប៉ះពាល់មូលដ្ឋានគ្រឹះ និងសោភ័ណភាពខាងក្រៅនៃអគារ ។
                  </p>
                </td>
              </tr>
               <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn">
                    若乙方有意维修或改变公寓规模，则必须有甲方的同意，而且该改变或维修不得影响到建筑物的基础和外观。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.5</p>
                </td>
                <td>
                  <p>
                    ក្នុងករណីចាំបាច់ ភាគី “ក” សុំរក្សាសិទ្ធិកែប្រែប្លង់រចនាសម្ព័ន្ធ និងប្លង់ដេគ័រខាងក្នុងខ្លះៗ ប៉ុន្តែរក្សាទំហំយូនីតខុនដូឱ្យនៅដដែល។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn">
                    如有必要，甲方保留修改结构和部分室内装饰的权利，但保持公寓单元的面积不变。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">4.6</p>
                </td>
                <td>
                  <p>
                    ភាគី “ក” ធានាជួសជុលជូនរយៈពេល01ឆ្នាំឥតគិតថ្លៃ លើជម្រាបទឹក ការប្រេះស្រាំជញ្ជាំងក្នុងយូនីតខុនដូរបស់ភាគី “ខ” (គិតចាប់ពីថ្ងៃដែលក្រុមហ៊ុនប្រកាស់សេចក្តីជូនដំណឹងស្តីពីការប្រគល់-ទទួល យូនីតខុនដូតទៅ)។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn">
                    甲方保证乙方公寓墙体防水、裂缝等问题免费维修1年（自公司发布公寓交房通知之日起）。
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr>
                <td colspan="2">
                  <p class="khm">
                    ប្រការ 5: ការផ្ទេរសិទ្ធិ
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p class="cnb">
                    第五条 ：产权转让
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli">5.1</p></td>
                <td>
                  <p style="text-align: justify;">
                    ក្នុងកំលុងពេលសាងសង់ ភាគី “ខ”  អាចលក់ ឬផ្ទេរកិច្ចព្រមព្រៀង លក់-ទិញ ខុនដូនេះបាន ដោយមានការឯកភាពជាលាយ លក្ខណ៍អក្សរពីភាគី “ក”  ហើយភាគី “ខ”  ត្រូវបង់ថ្លៃផ្ទេរឈ្មោះចំនួនៈ <span class="number">USD200</span> (ពីររយដុល្លារអាមេរិក) ជូនភាគី “ក” ។ ភាគីអ្នកទិញបន្ត ឬអ្នកដែលទទួលយកការផ្ទេរកិច្ចព្រមព្រៀងពីភាគី “ខ”  ត្រូវគោរពតាមខ្លឹមសារទាំងស្រុងនៃកិច្ចព្រមព្រៀងនេះ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"></td>
                <td>
                  <p class="cn text-cn" style="text-align: justify;">
                    在建设期间，乙方可以出售或转让本公寓买卖协议，但是应有甲方的书面同意，而且乙方应支付USD200（贰佰美元）的过户费。后续的买方或乙方的协议受让人应遵从本协议所载全部内容
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli">5.2</p></td>
                <td>
                  <p style="text-align: justify;">
                    នៅពេលអគារខុនដូសាងសង់រួចរាល់ភាគី “ក” នឹងបំបែកប័ណ្ណសហកម្មសិទ្ធិជូនភាគី “ខ” ដោយថ្លៃសោហ៊ុយជាបន្ទុករបស់ភាគី “ក” ។ ភាគី “ក” នឹងជូនដំណឹងជាលាយលក្ខណ៍អក្សរមកភាគី “ខ” រយៈពេល15ថ្ងៃដើម្បីឱ្យភាគី “ខ” មកពិនិត្យនិងទទួលយក
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli"></p></td>
                <td>
                  <p style="text-align: justify;">
                    ខុនដូរបស់ខ្លួន ។ ក្នុងរយៈពេលជូនដំណឹង15ថ្ងៃនេះបើភាគី “ខ” មិនបានឆ្លើយតប ឬមិនបានមកពិនិត្យមើលនោះទេ ចាត់ទុកថាភាគី “ខ” បានឯកភាពទទួលយកហើយ និងបង់ប្រាក់ថ្លៃទិញខុនដូខាងលើជូនភាគី “ក” តាមកាលវិភាគបង់ប្រាក់ដែលបានភ្ជាប់ជាឧបសម្ព័ន្ធនៃកិច្ចព្រមព្រៀងនេះ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"></td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    公寓建设竣工后，甲方将为乙方分契产权，费用由甲方承担。甲方将以书面形式通知乙方15天以便让乙方来检查及接受自己的公寓单元。在这15天通知期间，若乙方没有回覆或没有来检查，则视为乙方已经同意接受，并且应按照本协议所附的付款时间表支付以上公寓单元款项给甲方。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">5.3</p>
                </td>
                <td>
                  <p>
                    ក្រោយពេលភាគី “ខ” បានទូទាត់ថ្លៃទិញខុនដូជូនភាគី “ក” គ្រប់ចំនួនហើយ ភាគី “ក” នឹងសហការផ្តឹតមេដៃលើឯកសារផ្ទេរឈ្មោះពីភាគី “ក” ទៅភាគី “ខ” ដោយថ្លៃសោហ៊ុយលើការផ្ទេរសិទ្ធិនេះជាបន្ទុករបស់ភាគី “ខ” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn">
                    乙方支付足额公寓单元款项给甲方后，甲方将配合在文件上按拇指印以从甲方名字过户到乙方名下，而这转让费由乙方承担。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                  <p class="khli">5.4</p>
                </td>
                <td>
                  <p>
                    ភាគី “ក” ធានាអះអាងថាខុនដូដែលបានលក់ជូនភាគី “ខ” ក្នុងកិច្ចព្រមព្រៀងនេះពិតជារបស់ខ្លួន ពុំមានលក់ដូរ ជួល ផ្ទេរសិទ្ធិ ធ្វើអំណោយ ជាប់បញ្ចាំ ជាប់ការហាមឃាត់ ឬជាប់បន្ទុកណាមួយឡើយ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right">
                </td>
                <td>
                  <p class="cn">
                    甲方保证在本协议中出售给乙方的公寓单元确实在自己的所有权下，没有出售、交换、出租、转让、赠送、抵押、被禁止或涉及任何负担。
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr>
                <td colspan="2"><p class="khm">ប្រការ 6: ការបង់ពន្ធ និង ថ្លៃសេវាកម្ម</p></td>
              </tr>
              <tr>
                <td colspan="2"><p class="cnb">第六条 ：缴税和支付服务费</p></td>
              </tr>
              <tr>
                <td class="right"><p class="khli">6.1</p></td>
                <td>
                  <p style="text-align: justify;">
                  នៅក្នុងកំលុងពេលសាងសង់ និងមុនពេលប្រគល់ខុនដូជូនភាគី “ខ” ចំណាយលើការបង់ពន្ធជូនរដ្ឋ និងថ្លៃសេវាផ្សេងៗជាបន្ទុករបស់ភាគី “ក” ។ ប៉ុន្តែបន្ទាប់ពីបានប្រគល់ និងទទួលសិទ្ធិចូលស្នាក់នៅរួចរាល់ តទៅចំណាយលើការបង់ពន្ធលើអចលនៈទ្រព្យ និងថ្លៃសេវាផ្សេងៗទៀតជាបន្ទុករបស់ភាគី “ខ” ទាំងស្រុង ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"></td>
                <td>
                  <p class="cn" style="text-align: justify;">
                  在施工期间及移交公寓单元给乙方之前，甲方应负责缴纳税务给政府及支付各种服务费。但是，在移交并入住后，不动产的税务缴纳和其他服务费均由乙方承担。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli">6.2</p></td>
                <td>
                  <p style="text-align: justify;">
                  គិតចាប់ពីថ្ងៃបានទទួលសិទ្ធិចូលស្នាក់នៅ ភាគី “ខ” សន្យាថាយល់ព្រមឱ្យភាគី “ក” ឬ(ក្រុមហ៊ុនដែលកំណត់ដោយភាគី “ក”) ទទួលខុសត្រូវលើការគ្រប់គ្រងលើអគារខុនដូនេះទាំងស្រុង ។ ភាគី “ខ” មានកាតព្វកិច្ចបង់ថ្លៃសេវាប្រចាំខែចំនួនៈ <span class="number">USD0.50</span> (សូន្យចុចប្រាំដុល្លារអាមេរិក) ក្នុង1ម៉ែត្រការ៉េ នៃទំហំរួមនៃយូនីត ដែលជាបទដ្ឋានគោលនៃការគណនា ។ សេវាកម្មនេះរួមមានដូចជា៖ ភ្លើង បំភ្លឺផ្លូវ អនាម័យ សន្តិសុខ ជណ្តើយន្ត ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"></td>
                <td>
                  <p class="cn" style="text-align: justify;">
                  自入住之日起，乙方承诺及同意让甲方或（甲方指定公司）负责管理整个公寓。乙方有义务按照基本计算标准支付公寓共有面积每平方米USD0.5（伍拾美分）的每月服务费。这些服务费包括：道路照明等、卫生、保安、电梯等。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli">6.3</p></td>
                <td>
                  <p style="text-align: justify;">
                    ថ្លៃសោហ៊ុយប្រើប្រាស់ចរន្តអគ្គិសនី និងទឹកជាបន្ទុករបស់ភាគី “ខ” ។ ភាគី “ខ” យល់ព្រមបង់ថ្លៃប្រើប្រាស់ចរន្តអគ្គិសនីប្រចាំខែចំនួនៈ <span class="number">USD0.25</span> (សូន្យចុចម្ភៃប្រាំដុល្លារអាមេរិក) ក្នុង1គីឡូវ៉ាត់ម៉ោង និងថ្លៃប្រើប្រាស់ទឹកប្រចាំខែចំនួនៈ <span class="number">3,000</span>រៀល (បីពាន់រៀល) ក្នុង1ម៉ែត្រគូបជូនភាគី “ក” ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"></td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    乙方应负责支付水电费给甲方。乙方同意支付每月电费为：1度USD0.25（贰拾伍美分），以及每月水费为：1立方米3,000瑞尔（叁仟瑞尔）。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli">6.4</p></td>
                <td>
                  <p style="text-align: justify;">
                    ក្នុងករណីភាគី “ខ” មានរថយន្ត ហើយប្រើប្រាស់ចំណតក្នុងអគារខុនដូ ភាគី “ខ” ត្រូវបង់ថ្លៃចំណតជូនភាគី “ក” ចំនួនៈ <span class="number">USD40</span> (សែសិបដុល្លារអាមេរិក) ក្នុង1ខែសម្រាប់1ចំណត ចំពោះម៉ូតូផ្តល់ជូន2ចំណត សម្រាប់1យូនីតដោយមិនគិតថ្លៃ ។ យោងលើស្ថានភាពសេដ្ឋកិច្ចជាក់ស្តែង ភាគី “ក” ឬ (ក្រុមហ៊ុនដែលកំណត់ដោយភាគី “ក”) មានសិទ្ធិក្នុងការកែប្រែតម្លៃនេះបាន ដោយជូនដំណឹងជាសាធាណៈរយៈពេល1ខែជាមុន ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"></td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    若乙方有汽车，并且使用公寓的停车位，则乙方应每月支付USD40（肆拾美元）的一个汽车停车位费给甲方，每个公寓单元可获得免费的两个摩托车停车位。根据实际经济情况，甲方或（甲方指定公司）有权改变这价格，但是应提前一个月发出公共通知。
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr><td colspan="2"><p class="khm">ប្រការ 7: ការប្រើប្រាស់បន្ទប់ខុនដូ</p></td></tr>
              <tr><td colspan="2"><p class="cnb">第七条 ：公寓单元的使用</p></td></tr>
              <tr>
                <td class="right"><p class="khli">7.1</p></td>
                <td>
                  <p style="text-align: justify;">
                    គិតចាប់ពីថ្ងៃបានទទួលសិទ្ធិចូលស្នាក់នៅ ភាគី “ខ” សន្យាថាគោរពយ៉ាងម៉ឺងម៉ាត់តាមបទបញ្ជាផ្ទៃក្នុងដែលកំណត់ដោយភាគី “ក” ឬ(ក្រុមហ៊ុនដែលកំណត់ដោយភាគី “ក”) មានដូចជា៖សណ្តាប់ធ្នាប់ សុវត្ថិភាព អនាម័យ ហាមចិញ្ចឹមសត្វ (ឆ្កែ-ឆ្មា-បក្សី និងសត្វផ្សេងៗ ទៀត) ហាមស្រែកឡូឡាខ្លាំងៗ ការបំពុលបរិស្ថាន មិនអនុញ្ញាតឱ្យនាំចូលអាវុធជាតិផ្ទុះខុសច្បាប់ ហាមជួញដូរនិងប្រើប្រាស់គ្រឿងញៀន មិនអនុញ្ញាតឱ្យបើកបនល្បែងគ្រប់ប្រភេទ ហាងលក់ទំនិញ ឬបើកជាក្រុមហ៊ុន គឺសំរាប់តែការស្នាក់នៅប៉ុណ្ណោះ ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"></td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    自入住之日起，乙方承诺严格遵守甲方或（甲方指定公司）规定的内部规章，如：秩序、安全、禁止饲养动物（狗、猫、飞禽和其他动物）、禁止大声喧闹、污染环境、不得携带非法武器和爆炸物进入公寓、禁止交易和使用毒品、不得开赌场、商店或设立公司，即仅可以用于居住。
                  </p>
                </td>
              </tr>
              
            
              <tr>
                <td class="right"><p class="khli">7.2</p></td>
                <td>
                  <p style="text-align: justify;">
                    ប្រសិនបើភាគី “ខ” ជួលខុនដូរបស់ខ្លួនទៅឱ្យអតិថិជនផ្សេង ភាគី “ខ” ត្រូវជូនដំណឹងមកភាគី “ក” និងផ្តល់កិច្ចសន្យាជួល1ច្បាប់ ព្រមទាំងអត្តសញ្ញាណអ្នកជួលនោះមកឱ្យភាគី “ក” មុនពេលអនុញ្ញាតឱ្យអ្នកជួលចូលស្នាក់នៅ ។ ហើយភាគី “ខ” ត្រូវធានាថាអ្នកជួលនោះ នឹងគោរពអនុវត្តតាមប្រការទាំងឡាយដែលមានចែងក្នុងកិច្ចព្រមព្រៀងនេះ ប្រសិនបើអ្នកជួលនោះមិនបានគោរពតាម ភាគី “ខ” ជាអ្នកទទួលខុសត្រូវទាំងស្រុងក្នុងការដោះស្រាយរាល់បញ្ហាដែលកើតមានឡើង ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"></td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    若乙方出租自己的公寓单元给其他人，则乙方应通知甲方，并且提供一份租赁合同及该承租方的身份证给甲方后才可以让该承租方入住。乙方应保证该承租方将遵守本协议所载全部条款。若该承租方不遵从，则乙方应负责解决所有问题。
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"><p class="khli">7.3</p></td>
                <td>
                  <p style="text-align: justify;">
                    ភាគី “ខ” មិនត្រូវកែប្រែរចនាសម្ព័ន្ធ និងសោភ័ណភាពយូនីតខុនដូផ្នែកខាងក្រៅបានឡើយ ។ ក្នុងករណីភាគី “ខ” កំពុងជាប់បង់ប្រាក់រំលស់ នោះរចនាសម្ព័ន្ធស្តង់ដាដើមក្នុងផ្ទៃយូនីតខុនដូ នឹងមិនត្រូវបានអនុញ្ញាតឱ្យកែប្រែ ឬផ្លាស់ប្តូរជាដាច់ខាត ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"></td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    乙方不得变更公寓结构和外观。若乙方还正在分期付款，则公寓单元内部原标准结构不得有变更或改变
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr><td colspan="2"><p class="khm">ប្រការ 8: ការដោះស្រាយវិវាទ</p></td></tr>
              <tr><td colspan="2"><p class="cnb">第八条 ：争议解决</p></td></tr>
              <tr>
                <td class="right"><p class="khli">8.1</p></td>
                <td>
                  <p style="text-align: justify;">
                    ក្នុងករណីមានវិវាទកើតឡើង កិច្ចព្រមព្រៀងនេះ ភាគីទាំងពីរយល់ព្រមគ្នាដោយការចរចា ប៉ុន្តែបើមិនអាចដោះស្រាយតាមវិធីនេះទេ <span class="khm">តុលាការនៃព្រះរាជាណាចក្រកម្ពុជា</span> ជាអ្នកមានសមត្ថកិច្ច ។
                  </p>
                </td>
              </tr>
              <tr>
                <td class="right"></td>
                <td>
                  <p class="cn" style="text-align: justify;">
                    若本协议发生争议，双方同意谈判解决，但是若这方法不能解决，则应交给柬埔寨王国职能法院解决。
                  </p>
                </td>
              </tr>
              <tr><td colspan="2"><p style="height:10pt;"></p></td></tr>
              <tr><td colspan="2"><p class="khm">ប្រការ 9 អវសានបញ្ញាត្តិ</p></td></tr>
              <tr><td colspan="2"><p class="cnb">第九条 ：最后条款</p></td></tr>
              <tr>
                <td class="right"><p class="khli">9.1</p></td>
                <td><p style="text-align: justify;">កិច្ចព្រមព្រៀងនេះជាច្បាប់សម្រាប់គូភាគីអនុវត្ត អាចកែប្រែបានលុះត្រាតែមានការព្រមព្រៀងគ្នារវាងគូភាគីទាំងពីរ។</p></td>
              </tr>
              <tr>
                <td class="right"></td>
                <td><p style="text-align: justify;">本协议是双方执行的法律，并且必须有双方的约定方可以变更。</p></td>
              </tr>
              <tr>
                <td class="right"><p class="khli">9.2</p></td>
                <td><p class="cn" style="text-align: justify;">សុពលភាពនៃកិច្ចព្រមព្រៀងនេះត្រូវបញ្ចប់ នៅពេលដែលគូភាគីបានអនុវត្តកាតព្វកិច្ច ចប់សព្វគ្រប់តាមកិច្ចព្រមព្រៀងនេះ។</p></td>
              </tr>
              <tr>
                <td class="right"></td>
                <td><p class="cn" style="text-align: justify;">本协议效力在双方执行完毕本协议所载全部义务后将结束。</p></td>
              </tr>
              <tr>
                <td class="right"><p class="khli">9.3</p></td>
                <td><p style="text-align: justify;">គូភាគីបានអាននិងយល់រាល់ខ្លឹមសារពីប្រការ1 ដល់ប្រការ9 ហើយប្តេជ្ញាអនុវត្តតាមកិច្ចព្រមព្រៀងនេះយ៉ាងម៉ឺងម៉ាត់ និងផ្តិតមេដៃលើកិច្ចព្រមព្រៀងនេះទុកជាភស្តុតាង ដោយស្មារតីត្រឹមត្រូវ និងមិនមានការគំរាមកំហែង បង្ខិតបង្ខំពីជនណាម្នាក់ឡើយ ។</p></td>
              </tr>
              <tr>
                <td class="right"></td>
                <td><p class="cn" style="text-align: justify;">双方已阅读及理解第一条到第九条的全部内容，并且下决心严格执行本协议，而且在精神良好及没有受到任何一方逼迫或威胁的情况下在本协议上按拇指印为证。</p></td>
              </tr>
              <tr>
                <td class="right"><p class="khli">9.4</p></td>
                <td><p style="text-align: justify;">កិច្ចព្រមព្រៀងនេះធ្វើឡើងចំនួន2ច្បាប់ មានតម្លៃអនុវត្តស្មើៗគ្នា រក្សាទុកនៅភាគី “ក” ចំនួន1ច្បាប់ និងភាគី “ខ” ចំនួន1ច្បាប់។</p></td>
              </tr>
              <tr>
                <td class="right"></td>
                <td><p class="cn" style="text-align: justify;">本协议一式二份，均具同等法律效力，甲方执一份，乙方执一份。</p></td>
              </tr>
              <tr>
                <td class="right"><p class="khli">9.5</p></td>
                <td><p style="text-align: justify;">កិច្ចព្រមព្រៀងនេះធ្វើឡើងជា០២ភាសារ (ខ្មែរ និង ចិន) យកភាសារខ្មែរជាគោល និងអាទិភាពក្នុងការដោះស្រាយ ។</p></td>
              </tr>
              <tr>
                <td class="right"></td>
                <td><p class="cn" style="text-align: justify;">本合同以柬文和中文书写，争议解决优先以柬文为主。</p></td>
              </tr>
              <tr>
                <td class="right"><p class="khli">9.6</p></td>
                <td><p style="text-align: justify;">កិច្ចព្រមព្រៀងនេះមានចូលជាធរមានសម្រាប់គូភាគីអនុវត្តតាម ចាប់ពីថ្ងៃផ្តិតស្នាមមេដៃនេះតទៅ ។</p></td>
              </tr>
              <tr>
                <td class="right"></td>
                <td><p class="cn" style="text-align: justify;">本协议自按拇指印之日起立即有效执行。</p></td>
              </tr>
              <tr><td colspan="2"><p>&nbsp;</p></td></tr>
              <tr><td colspan="2" class="right"><p>ធ្វើនៅរាជធានីភ្នំពេញ,  ថ្ងៃទី {{saleDates[0]}} ខែ {{saleDates[1]}} ឆ្នាំ {{saleDates[2]}} </p></td></tr>
              <tr><td colspan="2" class="right"><p class="cn">金边市, {{saleDates_en[0]}} 年 {{saleDates_en[1]}} 月 {{saleDates_en[2]}} 日 </p></td></tr>
            </table>
            <br/><br/>
            <table width="100%">
              <tr>
                <td>
                  <p style="text-align: center; font-size: 12pt" class="khm">ស្នាមមេដៃ ភាគី “ខ”<br/>
                  <span style="text-align: center" class="cn">乙方拇指印</span></p>
                </td>
                <td v-for="(partner, index) in partners" :key="index">
                  <p style="text-align: center; font-size: 12pt" class="khm">ស្នាមមេដៃគូភាគី ភាគី “ខ”<br/>
                  <span style="text-align: center" class="cn">乙方双方拇指印</span></p>
                </td>
                <td>
                  <p style="text-align: center; font-size: 12pt" class="khm">ស្នាមមេដៃភាគី “ក”<br/>
                  <span style="text-align: center" class="cn">甲方拇指印</span></p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p style="text-align: center; font-size: 12pt" class="khm">{{contract && contract.name}}</p>
                </td>
                <td v-for="(partner, index) in partners" :key="index">
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p style="text-align: center; font-size: 12pt" class="khm">{{partner.partner_name}}<br/>
                  {{partner.partner_name_en}}</p>
                </td>
                <td>
                  <p>
                    <br/><br/><br/><br/>
                  </p>
                  <p style="text-align: center; font-size: 12pt" class="khm">លឹម ទ្រី<br/>
                  <span style="text-align: center" class="cn">LIM TRY</span></p>

                </td>
              </tr>
            </table>
          </div>
        </center>
  </Layout>
</template>